import { Container } from '@chakra-ui/react'
import { Outlet } from 'react-router-dom'

const FraudManagementLayout = () => {
  return (
    <Container maxW='full' bg={'chakra-body-bg'} py='1em' px='1.5em'>
      <Outlet />
    </Container>
  )
}

export default FraudManagementLayout